import { render, staticRenderFns } from "./PasoUnoComponent.vue?vue&type=template&id=27d1bbbc"
import script from "./PasoUnoComponent.vue?vue&type=script&lang=js"
export * from "./PasoUnoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports